/**
 * This is to be used sparingly, it's for when we have shared content between the main website and the multi-compare app.
 */

const openCashbackModal = (): void => {
    if (!window.lightWindowManager) {
        window.open("/terms-and-conditions/cashback.aspx", "_blank");
    } else {
        window.lightWindowManager.open({
            name: "cashback",
            filePath: "/page_fragments/lightwindow_cashback.aspx"
        });
    }
};

// promotion
const openPromotion = (promotion: string): void => {
    window.lightWindowManager.open({
        name: promotion,
        filePath: `/page_fragments/lightwindow_promotion.aspx?key=${promotion}`
    });
};

// contact
const openContactModal = (): void => {
    window.lightWindowManager.open({
        name: "contact"
    });
};

interface IUseLightWindow {
    openCashbackModal: typeof openCashbackModal;
    openPromotion: typeof openPromotion;
    openContactModal: typeof openContactModal;
}

const useLightwindow = (): IUseLightWindow => {
    return { openCashbackModal, openPromotion, openContactModal };
};

export default useLightwindow;
